<template>
  <div class="container">
      <div class="topBlock ">
          <div class="ImgBlock">
            <el-image   style="height:80px;"  :src="url" :preview-src-list="srcList" />
          </div>
          <div class="warp-text">
               <div class="name">{{PrductName}}</div>
               <div class="text-block">
                    <div class="block" v-for="(item,index) in headerData">
                        <span class="title">{{item.title}}</span>
                        <span class="titleText">{{item.val}}</span>
                    </div>
               </div>
          </div>
      </div>
      <div class="common-items-center common-space-between">
        <div class="common-items-center">
          <div class="common-flex">
            <span style="font-size:15px;">IMEI：</span> 
            <el-input :size="this.$store.state.tableSize" v-model="serialNo" placeholder="请输入IMEI" style="margin-right:10px"></el-input>
          </div>
          <div class="common-flex">
            <span style="font-size:15px;">工程商：</span> 
            <el-input :size="this.$store.state.tableSize" v-model="deviceName" placeholder="请输入产品名称" style="margin-right:10px;width:150px"></el-input>
          </div>

           <el-button size="small" type="primary" icon="el-icon-search" @click="serachBtn">查询</el-button>
           <el-button size="small" type="danger"  icon="el-icon-refresh-left" @click="resetBtn">重置</el-button>
        </div>
        <div>
          <el-button size="small" type="primary" icon="el-icon-download"   @click="serachBtn">导出</el-button>
          <el-button size="small" type="danger"  icon="el-icon-arrow-left" @click="goBackBTN">返回</el-button>
        </div>
     </div>
      <div class="warp-table">
        
          <el-table ref="giftTable" :data="tableData" :empty-text="this.$store.state.tableEmpty" :size="this.$store.state.inputSize" style="width: 100%"  row-key="id"  :height="this.$store.state.windowHeight-375" lazy   @selection-change="checkSelectBtn">
              <el-table-column  align="center" header-align="center" :show-overflow-tooltip="true" type="selection"    width="55"></el-table-column>
              <el-table-column  align="left" header-align="left"     :show-overflow-tooltip="true" prop="id"           label="产品设备ID" width="200"></el-table-column>
              <el-table-column  align="left" header-align="left"     :show-overflow-tooltip="true" prop="serialNo"      label="序列号/IMEI" width="200"></el-table-column>
              <el-table-column  align="left" header-align="left"     :show-overflow-tooltip="true" prop="serialNo"      label="设备名称" >
                  <template slot-scope="scope">
                     {{scope.row.deviceName | TutOutB}}
                  </template>
              </el-table-column>
              <el-table-column  align="left" header-align="left"   :show-overflow-tooltip="true" prop="engineerName"      label="工程商" />
              <el-table-column  align="left" header-align="left"   :show-overflow-tooltip="true" prop="engineerPhone"      label="电话" />
              <template v-if='mark'>
                <el-table-column  align="left" header-align="left"   :show-overflow-tooltip="true" prop="projectName"   label="项目名称" />
              </template>
              <el-table-column  align="left"   header-align="left" :show-overflow-tooltip="true" prop="createTime"      label="创建时间"/>    
              <el-table-column  align="center" header-align="center" :show-overflow-tooltip="true" prop="address"     label="二维码" >
                  <template slot-scope="scope">
                    <div class="common-width common-space-around">
                      <Qrcode :mark="scope.row.serialNo"/>
                    </div>
                  </template>
              </el-table-column>
          </el-table>
          <Paging @getPage="getPage" :total="total" :pageNo="current" :size="size"/>
      </div>
      <LookBlock ref="lookBlock"></LookBlock> 
  </div>
</template>

<script>
import { scroll } from '@/components/component-mixin/block-scroll'
import {userApi,operate,url,api} from '@/utils/config'
import {postFun,deleteFun,putFun,getFun} from '@/utils/httpFun'
import {getParms} from '@/utils/util'
import LookBlock from './block-info.vue'
export default {
  name: 'index',
  mixins: [scroll],
  components:{
    LookBlock
  },
  data:()=>({  
    queueID:0,
    inputName:"",
    factoryId:0,
    mark:true,
    url: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fimg.91huoke.com%2Fxxfl%2Fhk91%2Fcustomer%2F44239%2F%2FguwxrAcdyOngHAasKQRhYTSP1gZLxyJ1C0nmkYnY.jpeg&refer=http%3A%2F%2Fimg.91huoke.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1674196876&t=f101edbb9a2c108b8c7ea9214f188def',
    srcList: [],
    tableData: [],
    PrductName:"",
    headerData:[],
    deviceName:null,
    serialNo:null,
    current:1,
    size:10,
    total:10,   
  }),
  created(){
    this.size = this.$store.state.pageSize
    let parms = JSON.parse(localStorage.getItem("ImeiListData")) 
    this.PrductName =  parms.name    
    this.headerData=[
      {title:"产品分类：",val:parms.deviceTypeName},
      {title:"企业名称：",val:parms.factoryName},
      {title:"协议名称：",val:parms.protocolName},
      {title:"待安装数：",val:parms.deviceInstalledCount},
      {title:"设备分类：",val:parms.deviceTypeName},
      {title:"协议版本：",val:parms.protocolVersion},
    ]   
    this.mark = parms.mark
    this.factoryId = parms.factoryId
    this.getDatas()
  },
  methods:{

    //获取所有的数据
    async getDatas(){
      let parms = {
          param:{
            factoryId:this.factoryId,
            deviceName:this.deviceName,
            serialNo:this.serialNo,
            hasBingding:this.mark ? 1:0
          },
          
          current:this.current,
          size:this.size
        }
        await postFun(operate.PRODUCTIMEILIST,parms,res=>{
            console.log("数据",res)
             this.tableData = res.data.records 
             this.total = res.data.total
             this.size = res.data.size
             this.current = res.data.current
        })
    },
    //获取输入框/选择框的值
    getVal(ev){
       if(ev.key=="keyWord"){
           this.formData.keyWord = ev.val
       }
       if(ev.key=="status"){
           this.formData.status = ev.indexNo
       }
    },
    
    //查询
    serachBtn(){
       this.getDatas()
    },
    
    //重置
    resetBtn(){
       this.factoryName = null
       this.current = 1
       this.getDatas()
    },
    
   //多选
    checkSelectBtn(ev){
       console.log(ev)
    },
     
    //查看产品名称的详情
     openProduct(ev){
      getFun(operate.PRODUCTDETAIL+"/"+ev.id,{},res=>{
          let data = res.data
          let parms = {
              imgList:res.resources,
              prdocutName:data.name,
              describes:data.describes,
              list:[
                {title:"产品分类",val:data.deviceTypeName},
                {title:"设备分类",val:data.typeName},
                {title:"产品型号",val:data.model},
                {title:"企业名称",val:data.factoryName},
                {title:"协议名称",val:data.protocolName},
                {title:"更新时间",val:data.updateTime},
                {title:"协议公司",val:data.factoryName},
                {title:"最近操作人",val:data.operator},
                {title:"版本",val:data.protocolVersion}
              ]
            }
          let dataParms = {
                bucketName: api.bucketName,
                objectNames: (res.resources).join(",")
          }  
          postFun(url.SHOWIMGMORE,dataParms,resdata=>{
               console.log("图片地址",resdata)
          })  
          // this.$refs.lookBlock.openBtn(parms)
        })
     }, 
     //返回上一页
     goBackBTN(){
        // this.$router.back(-1)
        // window.history.back()
        this.$router.replace({
             path:this.mark ? "Facility":"FacilityNo",
             query:{}
        })
     },

    //分页
    getPage(ev){
        this.size = ev.pageSize
        this.current = ev.pageNo 
        this.getDatas()
    }
  }
}
</script>
<style lang="scss" scoped>
    .container{
        padding:15px;
        box-sizing: border-box;
    }
    .topBlock{
      width: 100%;
      border-radius:3px;
      border-bottom: 1px solid rgba(228, 228, 228, 0.5);
      margin-bottom: 15px;
      padding:0 0 10px 0;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      .ImgBlock{
         height: 80px;
         width: 80px;
         overflow: hidden;
      }
      .warp-text{
         padding-left: 10px;
         .name{
           font-size:25px;
           color: #4D5C72;
         }
         .text-block{
           display: flex;
           flex-wrap: wrap;
           width:1020px;
           .block{
             width:340px;
             margin-top:5px;
           }
           .title{
             font-size: 14px;
             color: #4D5C72;
             position: relative;
           }
           .titleText{
              font-size: 14px;
              color: #4D5C72;
              position: relative;
           }
         }
      }
    }
    .warp-table{
        margin-top: 15px;
        width: 100%;
    }
    .lookName{
        color: #458EFF;
        cursor: pointer;
    }
</style>
